// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3PhNy","resendInfoText":"OnGoingPaymentBox_resendInfoText__3MbLD"};